import * as React from 'react'
export const LinkedinIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.6406 0H3.35938C1.51188 0 0 1.51188 0 3.35938V16.6406C0 18.4881 1.51188 20 3.35938 20H16.6406C18.4881 20 20 18.4881 20 16.6406V3.35938C20 1.51188 18.4881 0 16.6406 0ZM7.5 16.25H5V7.5H7.5V16.25ZM6.25 6.25C5.55938 6.25 5 5.69063 5 5C5 4.30938 5.55938 3.75 6.25 3.75C6.94063 3.75 7.5 4.30938 7.5 5C7.5 5.69063 6.94063 6.25 6.25 6.25ZM16.25 16.25H13.75V11.25C13.75 10.5594 13.1906 10 12.5 10C11.8094 10 11.25 10.5594 11.25 11.25V16.25H8.75V7.5H11.25V9.05188C11.7656 8.34375 12.5538 7.5 13.4375 7.5C14.9906 7.5 16.25 8.89937 16.25 10.625V16.25Z'
        fill='current'
      />
    </svg>
  )
}
